import * as types from "../constants/action_types";
import Api from "../api";

function fetchedCompany(company) {
  return { type: types.FETCH_COMPANY, company };
}

function updatedCompany(company) {
  return { type: types.UPDATE_COMPANY, company };
}

export function fetchCompany(name) {
  return function(dispatch) {
    return Api.showCompany(name).then(response => {
      dispatch(fetchedCompany(response));
    }).catch(error => {
      throw(error);
    });
  };
}

export function updateCompany(data) {
  return function(dispatch) {
    return Api.updateCompany(data).then(response => {
      dispatch(updatedCompany(response));
    }).catch(error => {
      throw(error);
    });
  };
}
